import { create } from "zustand";

import { STRINGS } from "../utils/strings";

const initialState = {
  data: [],
  loading: true,
  currentPage: STRINGS.DEFAULT_PAGE,
  resLimit: STRINGS.DEFAULT_PAGINATION_LIMIT,
  resultCount: 0,
  selectedPayment: null,
};

export const usePaymentStore = create((set) => ({
  ...initialState,
  setCurrentPage: (page) => set({ currentPage: page }),
  setData: (data) => set({ data }),
  setLoading: (loading) => set({ loading }),
  setResLimit: (limit) => set({ resLimit: limit }),
  setResultCount: (count) => set({ resultCount: count }),
  setSelectedPayment: (value) => set({ selectedPayment: value }),
  resetCurrentPage: () => set({ currentPage: STRINGS.DEFAULT_PAGE }),
  reset: () => set(initialState),
}));
